module.exports = __webpack_public_path__ + "img/app-check.78e0ac99.svg";